import { data } from '../../svg/Group/data';
import { makeIcon } from '../makeIcon';

export const Group = makeIcon(data, 'group', 'Group');

export default Group;
